import React from 'react';
import { Modal } from 'semantic-ui-react';

import Button from '../../../components/Button';
import { StandaloneChargeDTO } from '../../../services/standalone-charges';

type Props = {
  open: boolean;
  onClose: () => void;
  charge: StandaloneChargeDTO | null;
  loading: boolean;
  onConfirm: () => void;
};

const CancelChargeModal: React.FC<Props> = ({ open, onClose, charge, loading, onConfirm }) => {
  return (
    <Modal open={open} onClose={onClose} size="tiny" closeIcon>
      <Modal.Header>Cancelar cobrança</Modal.Header>
      <Modal.Content>
        <p>Tem certeza que deseja cancelar esta cobrança pendente?</p>
        {charge && (
          <p style={{ color: '#666', marginBottom: 0 }}>
            Pagador: <strong>{charge.payerName}</strong>
          </p>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" text="Manter cobrança" light onClick={onClose} />
        <Button
          type="button"
          text="Confirmar cancelamento"
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default CancelChargeModal;

